import React, { useState } from "react";
import { Formik } from "formik";
import FormInput from "../../../../../components/Universal/FormInput.component";
import DropDownInput from "../../../../../components/Universal/DropDownInput.component";
import DatePicker from "../../../../../components/Universal/DatePicker.component";
import { ReactComponent as FiPlus } from "../../../../../assets/Icons/Universal/PlusIconWithGreenBack.svg";

const Body = () => {
  const paymentModes = ["Cash", "Bank Transfer", "UPI", "Cheque"];
  const verifiers = ["Manager A", "Manager B", "Auditor X"];

  const [items, setItems] = useState([
    { itemName: "", quantity: "", price: "" },
  ]);

  const addItem = () => {
    setItems([...items, { itemName: "", quantity: "", price: "" }]);
  };

  return (
    <Formik
      initialValues={{
        b2bPartner: "",
        contact: "",
        deliveryDate: "",
        description: "",
        items: items,
        totalCost: 0,
        paidAmount: "",
        gst: "",
        verifier: "",
        paymentMode: "",
      }}
      onSubmit={(values) => {
        console.log("Submitted:", values);
      }}
    >
      {({ values, setFieldValue, handleSubmit, touched, errors }) => (
        <form onSubmit={handleSubmit} className="p-1">
          <div className="grid grid-cols-2 gap-4 mb-05">
            <FormInput
              name="b2bPartner"
              label="B2B partner/provider (if any)"
              type="text"
              placeholder="Enter name of partner"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("b2bPartner", e.target.value)}
            />
            <FormInput
              name="contact"
              label="Contact (if any)"
              type="text"
              placeholder="Enter phone number"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("contact", e.target.value)}
            />
            <DatePicker
              name="deliveryDate"
              label="Delivery date"
              value={values.deliveryDate}
              placeholder="Choose a date of delivery"
              setFieldValue={(val) => setFieldValue("deliveryDate", val)}
            />
            <FormInput
              name="description"
              label="Description"
              type="text"
              placeholder="Type something here"
              touched={touched}
              errors={errors}
              setFieldValue={(e) =>
                setFieldValue("description", e.target.value)
              }
            />
          </div>

          <h3 className="text-md font-semibold mt-4 mb-2 text-gray-500">
            Merchandise
          </h3>
          {items.map((item, index) => (
            <div key={index} className="grid grid-cols-3 gap-4 mb-2">
              <FormInput
                label="Item"
                type="text"
                name={`items[${index}].itemName`}
                value={item.itemName}
                placeholder="Enter item name"
                touched={touched}
                errors={errors}
                setFieldValue={(e) => {
                  const updated = [...items];
                  updated[index].itemName = e.target.value;
                  setItems(updated);
                  setFieldValue("items", updated);
                }}
              />
              <FormInput
                label="Quantity"
                type="text"
                name={`items[${index}].quantity`}
                value={item.quantity}
                placeholder="Enter item quantity"
                touched={touched}
                errors={errors}
                setFieldValue={(e) => {
                  const updated = [...items];
                  updated[index].quantity = e.target.value;
                  setItems(updated);
                  setFieldValue("items", updated);
                }}
              />
              <FormInput
                label="Price"
                type="number"
                name={`items[${index}].price`}
                value={item.price}
                placeholder="Enter total price"
                touched={touched}
                errors={errors}
                setFieldValue={(e) => {
                  const updated = [...items];
                  updated[index].price = e.target.value;
                  setItems(updated);
                  setFieldValue("items", updated);

                  const total = updated.reduce(
                    (sum, i) =>
                      sum +
                      (parseFloat(i.quantity) || 0) *
                        (parseFloat(i.price) || 0),
                    0
                  );
                  setFieldValue("totalCost", total);
                }}
              />
            </div>
          ))}

          <button
            type="button"
            onClick={addItem}
            style={{ display: "flex", alignItems: "center", gap: "6px" }}
            className="text-green-600 my-2"
          >
            <FiPlus style={{ width: "18px", height: "18px" }} /> Add
          </button>

          <div className="grid grid-cols-2 gap-4 mt-4">
            <FormInput
              name="totalCost"
              label="Total cost (INR)"
              type="number"
              value={values.totalCost}
              touched={touched}
              errors={errors}
              disabled
            />
            <FormInput
              name="paidAmount"
              label="Paid amount (INR)"
              type="number"
              placeholder="Enter paid amount"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("paidAmount", e.target.value)}
            />
            <FormInput
              name="gst"
              label="GST (if any)"
              type="number"
              placeholder="Enter GST in %"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("gst", e.target.value)}
            />
            <DropDownInput
              name="verifier"
              label="Verifier"
              value={values.verifier}
              placeholder="Choose payment verifier"
              suggestionList={verifiers}
              setFieldValue={(val) => setFieldValue("verifier", val)}
            />
            <DropDownInput
              name="paymentMode"
              label="Payment mode"
              value={values.paymentMode}
              placeholder="Choose payment mode"
              suggestionList={paymentModes}
              setFieldValue={(val) => setFieldValue("paymentMode", val)}
            />
          </div>

          <button type="submit" className="actionBtn w-full mt-6">
            {items.length > 1 ? "Update" : "Collect"}
          </button>
        </form>
      )}
    </Formik>
  );
};

export default Body;
